<template>
  <header class="slds-page-header" role="banner" style="padding:0px;">
    <div class="page-header slds-text-align_center slds-p-top_small slds-p-left_small slds-p-bottom_small slds-p-right_small slds-align_absolute-center">
      <div class="slds-text-heading_large slds-text-color_inverse" style="font-size:45px;line-height:64px;">Welcome to {{ orgType }}</div>
    </div>
  </header>
</template>

<script>
  import { mixpanelMixin } from '../mixpanelMixin';

  export default {
    name: 'PageHeader',
    mixins: [mixpanelMixin],
    data(){
      return{
        orgType : ''
      }
    },
    mounted(){
      this.orgType = new URLSearchParams(window.location.search).get("org_type_name");
    }
  }
</script>
<style scoped>
  .page-header{
    background: url("/trail-topichero.jpg");
    width: 100%;
    min-height: 150px;
  }
  input {
    height: 30px;
    padding-bottom: 8px;
    padding-top: 8px;
    width: 100%;
  }
  a {
  display: flex;
  align-items: center;
  }
  .slds-text-title >>> a{
    color: white;
  }
</style>